import { handleActions } from 'redux-actions';
import { LOCATION_CHANGE } from 'react-router-redux';

import _cloneDeep from 'lodash/fp/cloneDeep';

import http from '../../shared/http';
import endpoints from '../../../config/endpoints';
import intl from '../../shared/intl';
import checkPermissions from '../../shared/check-permissions';
import createTable from '../components/table';

const table = createTable({ namespace: 'missionsList',  stateNodeName: 'table' });

const FETCH_DATA_SUCCESS = 'missionsList/FETCH_DATA_SUCCESS';
const REMOVE_SUCCESS = 'missionsList/REMOVE_SUCCESS';
const REQUEST_ERROR = 'missionsList/REQUEST_ERROR';
const TOGGLE_PROGRESS_BAR = 'missionsList/TOGGLE_PROGRESS_BAR';
const DELETE_MISSION_SUCCESS = 'missionsList/DELETE_MISSION_SUCCESS';

export const allowedPermissions = {
	'view': 'missions_view',
	'edit': 'missions_update'
};

const initialState = {
	data: null,
	showProgressBar: false,
	table: table.initialState,
	search: '',
	error: false
};

export const actions = Object.assign(
	{
		fetchData: props => (dispatch, getState) => {
			return http({
				url: endpoints.MISSIONS.BASE,
				method: 'get',
				actions: [FETCH_DATA_SUCCESS, REQUEST_ERROR]
			})(dispatch);
		},

		remove: id => (dispatch, getState) => {
			return http({
				url: `${endpoints.MISSIONS.SINGLE.replace('{id}', id)}`,
				method: 'delete',
				actions: [DELETE_MISSION_SUCCESS]
			})(dispatch);
		},

		toggleProgressBar: () => ({
			type: TOGGLE_PROGRESS_BAR
		})
	},
	table.actions
);

const reducers = Object.assign(
	{
		[LOCATION_CHANGE]: (state, action) => {
			return { ...state, data: null};
		},
		[DELETE_MISSION_SUCCESS]: (state, action) => {
			return { ...state, data: null};
		},
		[FETCH_DATA_SUCCESS]: (state, action) => ({
			...state,
			data: action.payload.data,
			showProgressBar: false,
			error: false
		}),
		[REMOVE_SUCCESS]: (state, action) => ({
			...state
		}),
		[REQUEST_ERROR]: state => ({
			...state, showProgressBar: true
		}),
		[TOGGLE_PROGRESS_BAR]: state => ({ ...state, showProgressBar: true })
	},
	table.reducers
);

export default handleActions(reducers, _cloneDeep(initialState));

export const selectors = {
	getData: state => state.missionsList.data,
	getTable: table.selectors.getTable,
	getCan: state => checkPermissions(state, allowedPermissions),
	getIntl: state => intl(state),
	getProgressBar: state => state.missionsList.showProgressBar,
	getError: state => state.missionsList.error
};


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/missions/list/index.js